import _ from 'lodash'
import React from 'react'

import { REGION_RU, REGION_JP, REGION_EU } from 'constants/regions'
import { gtmEvent } from 'utils/client/analitics'

const fields = {
  [REGION_RU]: ['address', 'name', 'phone', 'email', 'payType'],
  [REGION_EU]: [
    'address',
    'address2',
    'address3',
    'region',
    'city',
    'find-address',
    'postcode',
    'name',
    'phone',
    'email',
  ],
  [REGION_JP]: [],
}

const region = process.env.region

const checkGtm = () => {
  const currentFields = fields[region]
  const gtmSend = {}

  return ({ touched, values }) => {
    if (Object.keys(gtmSend).length === currentFields.length) return

    currentFields.forEach(key => {
      if (!gtmSend[key] && !touched[key] && values[key]) {
        gtmEvent({ event: `Start fill - ${key}` })
        gtmSend[key] = true
      }
    })
  }
}

const sendGTM = checkGtm()

export const usePersonalInfoForm = ({ personalInfoChange }) => {
  const [isReady, setIsReady] = React.useState(false)
  const [errors, setErrors] = React.useState({})

  /*
   * Callback
   * > take `values, invalid, active` from Personal Info form
   * > set isValid flag for that form
   * > send data to redux when every input in form is blurred
   */
  const handlePersonFormChange = React.useCallback(
    ({ values, invalid, active, touched, errors }) => {
      sendGTM({ touched, values })

      setErrors(errors || {})
      setIsReady(!invalid)

      if (!active && !_.isEmpty(touched)) {
        personalInfoChange({ personalInfo: values })
      }
    },
    [setIsReady, personalInfoChange],
  )

  return [isReady, errors, handlePersonFormChange]
}
